<template>
  <div class="notifications" v-if="bubbleNum > 0">
    <div class="notifications__element" v-for="(message, index) in messages" :key="index" :class="[{'notifications__element--error': message.type === 'error'},{'notifications__element--success': message.type === 'success'},{'notifications__element--warn': message.type === 'warn'}]">
      <button class="btn btn__close" @click="close(index)"></button>
      <h1 class="notifications__title" v-text="message.title"></h1>
      <p class="notifications__text" v-text="message.text"></p>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      messages: {},
      bubbleNum: 0,
      bubblesInterval: null
    }
  },
  watch: {
    newMessage: function () {
      if (this.newMessage !== null) {
        this.messages[Date.now()] = this.newMessage
        this.bubbleNum = Object.keys(this.messages).length
        clearInterval(this.bubblesInterval)
        this.closeBubbles()
      }
    },
    bubbleNum: function () {
      if (this.bubbleNum === 0) {
        clearInterval(this.bubblesInterval)
      }
    }
  },
  methods: {
    close: function (key) {
      delete this.messages[key]
      this.bubbleNum = Object.keys(this.messages).length
    },
    closeBubbles: function () {
      this.bubblesInterval = setInterval(() => {
        let time = Date.now() - 4000
        for (var key in this.messages) {
          if (time > key) {
            delete this.messages[key]
            this.bubbleNum = Object.keys(this.messages).length
          }
        }
      }, 200)
    }
  },
  computed: {
    newMessage: function () {
      return this.$store.state.notification
    },
    bubbleLength: function () {
      if (this.bubbleNum > 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_notifications"
</style>



// WEBPACK FOOTER //
// src/components/layout/notifications.vue